import React, { Component } from "react";
import _ from "lodash";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { WithStyles, createStyles } from "@material-ui/core";
import { MyPATDialog, dateService } from "../../../common";
import {
  CONTENT_SUB_TYPE,
  EDIT_BUTTON_STYLE,
  FEEDBACK_AUTHOR_ACTIONS,
  FEEDBACK_VALIDATOR_ACTIONS,
  VALIDATION_PLACEHOLDER,
  VALIDATION_ROLES,
} from "../../helper/contentValidation";
import { getPropertyValue } from '../../../../utils';
import cx from 'classnames'
import ViewRejectionReasonModal from "../ContentRating/ViewRejectionReasonModal";

// @ts-ignore
const createRef = React.createRef;

const styles = (theme: Theme) =>
  createStyles({
    historyPanel: {
      paddingBottom: "105px",
      "& .listing": {
        listStyle: "none",
        padding: "0",
        "&>li": {
          display: "flex",
          borderBottom: "1px solid #DFDFDF",
          padding: "0 0 15px",
          marginBottom: "15px",
          "& .nameIcon": {
            width: "20px",
            minWidth: "20px",
            height: "20px",
            borderRadius: "50%",
            fontSize: "12px",
            fontWeight: 400,
            fontFamily: "Nunito",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            textTransform: "capitalize",
            "&.author": {
              backgroundColor: "#EFF9D9",
              color: "#30BE76",
            },
            "&.validator": {
              backgroundColor: "#F6EFFE",
              color: "#8E50D4",
            },
          },
          "& .rightColumn": {
            width: "calc(100% - 20px)",
            paddingLeft: "10px",
            "& .headingText": {
              fontSize: "18px",
              fontWeight: 400,
              lineHeight: "133%",
              color: "#333333",
              margin: "0 0 10px",
              "& .actionBy": {
                textTransform: "capitalize",
              },
              "& .lightText": {
                color: "#666666",
              },
              "& .textHighlighted": {
                color: "#333333",
                fontWeight: 700,
                textTransform: "capitalize",
              },
            },
            "& .timeText": {
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "138%",
              color: "#999999",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            },
            "& .rejectionReasonButton": {
              color: "#1D7DEA",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "19px",
              cursor: "pointer",
            },
            "& .timelineBlock": {
              margin: "15px 0",
              "& .timelineColumn": {
                padding: "10px 10px",
                display: "flex",
                position: "relative",
                alignItems: "center",
                borderRadius: "4px",
                backgroundColor: "#F8F8F8",
                marginLeft: "16px",
                marginBottom: "10px",
                "&::before": {
                  content: "''",
                  position: "absolute",
                  left: "-13px",
                  top: "0",
                  width: "1px",
                  height: "calc(100% + 10px)",
                  borderLeft: "1px dashed rgba(153, 153, 153, 0.6)",
                },
                "&::after": {
                  content: "''",
                  position: "absolute",
                  left: "-18px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "10px",
                  height: "10px",
                  backgroundColor: "#C2C2C2",
                  borderRadius: "50%",
                },
                "&:last-child": {
                  marginBottom: "0",
                  "&::before": {
                    height: "100%",
                  },
                },
                "& .timelineHeading": {
                  fontSize: "18px",
                  fontWeight: 400,
                  lineHeight: "133%",
                  color: "#666666",
                  width: "100%",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  paddingRight: "10px",
                  margin: 0,
                },
                "& .btnText": {
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Nunito",
                  lineHeight: "135%",
                  color: "#1D7DEA",
                  backgroundColor: "transparent",
                  border: "none",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                  "&:focus": {
                    outline: "none",
                  },
                },
              },
            },
            "& .versionColumn": {
              border: '1px solid #E6E6E6',
              borderRadius: '4px',
              padding: '10px 10px',
              marginTop: '12px',
              overflow: 'hidden',
              position: 'relative',
              "& .versionName": {
                color: '#999999',
                fontSize: '16px',
                fontWeight: 400,
                fontFamily: 'Nunito',
                lineHeight: '138%',
                marginBottom: '10px',
                display: 'block',
              },
              "& .versionHeading": {
                fontSize: '18px',
                fontWeight: 400,
                lineHeight: '138%',
                color: '#333333',
                margin: '0 0 5px',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                "&.darkText": {
                  fontWeight: 600,
                }
              },
              "& .versionPara": {
                fontSize: '18px',
                fontWeight: 400,
                lineHeight: '138%',
                color: '#333333',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                position: 'relative',
                margin: '6px 0 12px',
              },
              "& .imgBlock": {
                width: '80px',
                height: '80px',
                border: '1px solid #E6E6E6',
                display: 'inline-flex',
                padding: '4px 4px',
                alignItems: 'center',
                borderRadius: '2px',
                justifyContent: 'center',
                "& img": {
                  maxWidth: '100%',
                  maxHeight: '100%',
                  display: 'block',
                },
              },
              "& .columnList": {
                listStyle: 'none',
                paddingLeft: '0px',
                "& li": {
                  color: '#000000',
                  fontSize: '16px',
                  fontWeight: 400,
                  lineHeight: '138%',
                  position: 'relative',
                  paddingLeft: '0',
                  "&::before": {
                    position: 'relative',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    marginRight: '5px',
                  },
                },
                "&.alphabet": {
                  counterReset: 'alpha',
                  marginBottom: '10px',
                },
                "&.alphabet li::before": {
                  counterIncrement: 'alpha',
                  content: '"(" counter(alpha, upper-alpha) ") "',
                },
                "&.number": {
                  counterReset: 'numerical',
                },
                "&.number li::before": {
                  counterIncrement: 'numerical',
                  content: '"(" counter(numerical) ") "',
                },
                "&.optionNumber": {
                  counterReset: 'numerical',
                },
                "&.optionNumber li::before": {
                  counterIncrement: 'numerical',
                  content: '"(Option" counter(numerical) ") "',
                },
                "& .viewMoreText": {
                  color: '#1D7DEA',
                  fontSize: '16px',
                  fontWeight: 600,
                  lineHeight: '138%',
                  display: 'inline-block',
                  verticalAlign: 'bottom',
                  paddingLeft: '0',
                  cursor: 'pointer',
                }
              },
              '& .tabContent': {
                '& .tabList': {
                  listStyle: 'none',
                  marginBottom: '10px',
                  padding: '0',
                  display: 'flex',
                  margin: '0 -5px',
                  '& li': {
                    fontSize: '16px',
                    fontWeight: 400,
                    color: '#333333',
                    padding: '0 0 5px',
                    borderBottom: '1px solid transparent',
                    margin: '0 5px',
                    '&.active': {
                      borderBottomColor: '#1D7DEA',
                      color: '#1D7DEA',
                    }
                  }
                },
                '& .tabListContent': {
                  '& h6': {
                    fontSize: '18px',
                    fontWeight: 600,
                    color: '#333333',
                    margin: '0 0 5px',
                  },
                  '& p': {
                    fontSize: '15px',
                    fontWeight: 400,
                    color: '#000000',
                    margin: '0 0 15px',
                    '& pre': {
                      whiteSpace: 'pre-wrap',
                      margin: '0',
                    }
                  }
                }
              }
            },
            "& .downArrow": {
              margin: '-10px auto -22px',
              display: 'block',
              zIndex: 1,
              position: 'relative',
              "& img": {
                display: 'block',
                margin: '0 auto',
              }
            }
          },
        },
      },
    },
    contentData: {
      '& img': {
        width: '80px',
        height: '80px',
      }
    },
    viewMore: {
      position: 'absolute',
      bottom: '0',
      right: '0',
      background: 'white',
      display: 'none',
      width: '100%',
      textAlign: 'right',
      padding: '12px'
    },
    viewMoreBtn: {
      border: '0',
      outline: 'none',
      color: ' #1D7DEA',
      fontSize: '16px',
      fontWeight: 600,
      cursor: 'pointer',
      background: 'transparent'
    },
    confirmationDialog: {
      maxWidth: '100%',
      margin: '10px',
      '&>div': {
        width: 'auto',
        height: '100%',
      },
      '&>div>div': {
        padding: '0 !important',
        maxWidth: '500px',
        maxHeight: '100%',
        '& img': {
          width: '100%',
          height: '100%'
        }
      }
    }
  });

interface ContentValidationEditHistoryProps extends WithStyles<typeof styles> {
  editHistory: any;
  createNewValidationFeedback: Function;
  selectedQuestionRef: any;
}

interface ContentValidationEditHistoryStates {
  activeImageUrl: string;
  rejectionReasonsToShow: any;
  isViewRejectionReasonOpen: boolean;
}
class ContentValidationEditHistory extends Component<
  ContentValidationEditHistoryProps,
  ContentValidationEditHistoryStates
> {
  constructor(props: ContentValidationEditHistoryProps) {
    super(props);
    this.state = {
      activeImageUrl: '',
      rejectionReasonsToShow: [],
      isViewRejectionReasonOpen: false,
    };
  }

  componentDidMount(): void {
    const data = document.getElementsByClassName('versionColumn');
    Array.from(data).forEach((element: any) => {
      if (element.clientHeight > EDIT_BUTTON_STYLE.CONTAINER_HEIGHT) {
        const viewMoreButton = element.querySelector('.viewMore');
        if (viewMoreButton) {
          viewMoreButton.style.display = EDIT_BUTTON_STYLE.DISPLAY_BLOCK;
        }
        element.style.maxHeight = EDIT_BUTTON_STYLE.MAX_HEIGHT;
      }
    })
  }

  handleViewMoreClick = (event: any, ref: any) => {
    if (!ref.current) {
      return;
    }
    if (ref.current.style.maxHeight === EDIT_BUTTON_STYLE.FIT_CONTENT) {
      ref.current.style.maxHeight = EDIT_BUTTON_STYLE.MAX_HEIGHT;
      ref.current.style.paddingBottom = EDIT_BUTTON_STYLE.VIEW_MORE_PADDING;
      event.target.innerText = EDIT_BUTTON_STYLE.VIEW_MORE;
    } else {
      ref.current.style.maxHeight = EDIT_BUTTON_STYLE.FIT_CONTENT;
      ref.current.style.paddingBottom = EDIT_BUTTON_STYLE.VIEW_LESS_PADDING;
      event.target.innerText = EDIT_BUTTON_STYLE.VIEW_LESS;
    }
  }

  openFeedback = (feedback: any) => {
    const { createNewValidationFeedback, selectedQuestionRef } = this.props;
    feedback.disableEditing = true;
    createNewValidationFeedback &&
      createNewValidationFeedback(feedback.section, -1, feedback);
    selectedQuestionRef && selectedQuestionRef.current && selectedQuestionRef.current(feedback.contentId);
  };

  handleImageClick = (event: any) => {
    if (event.target.tagName === 'IMG') {
      const activeImageUrl = event.target.src;
      this.setState({ activeImageUrl });
    }
  }

  getContent = (content: any) => {
    return (
      <span onClick={this.handleImageClick}
       className={this.props.classes.contentData} dangerouslySetInnerHTML={{
      __html: content
    }}></span>)
  }


  getActionContentData = (authorAction: string, fromData: string) => {
    let activeComponent = (<></>);
    const contentData = getPropertyValue(authorAction, fromData);
    
    switch (getPropertyValue(authorAction, 'section')) {
      case CONTENT_SUB_TYPE.OPTIONS:
          activeComponent = <>
            {contentData.map((optionData:any,index:number)=>
              <div> (Option {index+1}) {this.getContent(optionData)}</div>
            )}
          </>
          break;
      
      case CONTENT_SUB_TYPE.CORRECT_ANSWER:
        activeComponent = this.getContent((Array.isArray(contentData.data)?contentData.join(','):contentData.data));
        break;
      
      case CONTENT_SUB_TYPE.SOLUTION: {
        let activeIndex = 0;
        activeComponent = (<div className='tabContent'>
          <ul className='tabList'>
            {(contentData || []).map((data: any, index: number) => 
              <li onClick={() => activeIndex = index}>Solution {index + 1}</li>)}
          </ul>
          <div className='tabListContent'>
            {(contentData[activeIndex].solutionSteps || []).map((data: any) => <>
              <h6>{data.stepNo}</h6>
              <p>
                {this.getContent(data.solution)}
              </p>
            </>)}
          </div>
        </div>);
        break;
      }

      case CONTENT_SUB_TYPE.EXTRA_TAGS:
        activeComponent = (<>{
          contentData.map((contentInfo: any) => <>
            {getPropertyValue(contentInfo, 'relation.name', '')} :
            {getPropertyValue(contentInfo, 'values', []).join(',')}
          </>)
        }
        </>);
        break;

      default: activeComponent =
            activeComponent= this.getContent(Array.isArray(contentData)?contentData.join(','):contentData);
    }

    return activeComponent;
  }

  getOrdinalSuffix = (n: any) => {
    n = +n;
    const lastDigit = n % 10;
    const lastTwoDigits = n % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return n + "th";
    }
    switch (lastDigit) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
      default:
        return n + "th";
    }
  };

  openViewRejectionReason = (editData: any) => {
    const rejectionReasonsToShow = [{
      rejectionComment: editData.validatorAction.rejectionComment || '',
      rejectionReasons: editData.validatorAction.rejectionReasons || [],
    }];
    this.setState({
      isViewRejectionReasonOpen: true,
      rejectionReasonsToShow,
    });
  }

  onRejectionReasonModalClose = () => {
    this.setState({ isViewRejectionReasonOpen: false });
  }

  render() {
    const { classes, editHistory = [] } = this.props;
    const {isViewRejectionReasonOpen, rejectionReasonsToShow} = this.state;
    return (
      <div className={classes.historyPanel}>
        <ul className="listing">
          {editHistory.map((editData: any, index: number) => {
            const fromRef = createRef();
            const toRef = createRef();
            return (
            <li key={index}>
              <span className={["nameIcon", editData.actionBy].join(" ")}>
                {editData.actionBy[0]}
              </span>
              <div className="rightColumn">
                <h6 className="headingText">
                  {editData.actionBy === VALIDATION_ROLES.AUTHOR ? (
                    <div
                      className={
                        [FEEDBACK_AUTHOR_ACTIONS.CREATED, FEEDBACK_AUTHOR_ACTIONS.MODIFIED].includes(editData.authorAction.action)
                          ? ""
                          : "lightText"
                      }
                    >
                      <span className="actionBy">{editData.actionBy}</span>{" "}
                        {VALIDATION_PLACEHOLDER[editData.authorAction.action] || editData.authorAction.action} {' '}
                      {[FEEDBACK_AUTHOR_ACTIONS.CREATED, FEEDBACK_AUTHOR_ACTIONS.MODIFIED].includes(editData.authorAction.action) ? (
                        editData.authorAction.action === FEEDBACK_AUTHOR_ACTIONS.CREATED ? "a question" : "the Published question"
                      ) : (
                        <span className="textHighlighted">
                          {editData.authorAction.section}
                        </span>
                      )}
                    </div>
                  ) : (
                    <>
                      {this.getOrdinalSuffix(
                        editData.validatorAction.validatorNumber
                      )}{" "}
                      <span className="actionBy">{editData.actionBy}</span> has{" "}
                      {editData.validatorAction.action} the question{" "}
                      {editData.validatorAction.action ===
                        FEEDBACK_VALIDATOR_ACTIONS.REJECTED && (
                        <>
                          with {editData.validatorAction.feedbacks.length}{" "}
                          Feedback
                        </>
                      )}
                    </>
                  )}
                </h6>
                <span className="timeText">
                  {dateService.timeSince(editData.date)}
                  {!!((editData.validatorAction || {}).rejectionReasons || []).length && <span className="rejectionReasonButton" onClick={() => this.openViewRejectionReason(editData)} >Rejection Reason</span>}
                </span>
                {editData.actionBy === VALIDATION_ROLES.VALIDATOR &&
                  editData.validatorAction.feedbacks &&
                  !!(editData.validatorAction.feedbacks || []).length && (
                    <div className="timelineBlock">
                      {editData.validatorAction.feedbacks.map(
                        (feedback: any, ind: number) => (
                          <div className="timelineColumn">
                            <h5 className="timelineHeading">
                              {feedback.actions[0].comment}
                            </h5>
                            <button className="btnText" onClick={() => this.openFeedback(feedback)}>View</button>
                          </div>
                        )
                      )}
                    </div>
                  )}
                {getPropertyValue(editData, 'authorAction.action') === FEEDBACK_AUTHOR_ACTIONS.EDITED && <>
                    <div className="versionColumn" ref={fromRef} >
                      <span className="versionName">Older Version</span>
                      {this.getActionContentData(editData.authorAction, 'from')}
                      <div className={cx(this.props.classes.viewMore, 'viewMore')}>
                        <button className={cx(this.props.classes.viewMoreBtn)} onClick={(event: any) => this.handleViewMoreClick(event, fromRef)}>View More</button>
                      </div>
                    </div>
                  <span className='downArrow'><img src="/assets/svg/contentValidation/version-down-arrow.svg" alt="Arrow" /></span>
                    <div className="versionColumn" ref={toRef} >
                      <span className="versionName" >New Version</span>
                      {this.getActionContentData(editData.authorAction, 'to')}
                      <div className={cx(this.props.classes.viewMore, 'viewMore')}>
                        <button className={cx(this.props.classes.viewMoreBtn)} onClick={(event: any) => this.handleViewMoreClick(event, toRef)}>View More</button>
                      </div>
                    </div>
                </>
                }
              </div>
            </li>
          )})}
        </ul>

        <MyPATDialog
          classes={{ root: classes.confirmationDialog }}
          dialogOpen={this.state.activeImageUrl}
          onDialogClose={() => this.setState({ activeImageUrl: '' })}
          dialogHeading='Preview'
        >
          <img src={this.state.activeImageUrl} alt='Content'/>
        </MyPATDialog>
        <ViewRejectionReasonModal isModalOpen={isViewRejectionReasonOpen} onModalClose={this.onRejectionReasonModalClose.bind(this)} rejectionReasonData={rejectionReasonsToShow}/>
      </div>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(ContentValidationEditHistory);
